import ReactDOM from "react-dom";

const HeaderMidPortal = ({ children }) => {
  const el = document.getElementById("hd_mid_container");
  if (el) {
    return ReactDOM.createPortal(children, el);
  } else {
    return null;
  }
  return ReactDOM.createPortal(children, el);
};

export default HeaderMidPortal;
